export class Conductor{
    id: string;
    nombre: string;
    documento: string;
}